import {
  GET_DISCOVERY_LOCATIONS,
  GET_DISCOVERY_LOCATIONS_FAILED,
  GET_DISCOVERY_LOCATIONS_SUCCESS,
  DELETE_DISCOVERY_LOCATION,
  DELETE_DISCOVERY_LOCATION_FAILED,
  DELETE_DISCOVERY_LOCATION_SUCCESS,
} from './actionTypes';

const initialState = {
  isLoadingDiscoveryLocations: false,
  isDeletingDiscoveryLocation: false,
  discoveryLocations: [],
  totalDiscoveryLocations: 0,
  lastDeletedDiscoveryId: null,
};

const discoveryLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DISCOVERY_LOCATIONS:
      return {
        ...state,
        isLoadingDiscoveryLocations: true,
      };

    case GET_DISCOVERY_LOCATIONS_SUCCESS:
      return {
        ...state,
        isLoadingDiscoveryLocations: false,
        discoveryLocations: action.payload?.data || [],
        totalDiscoveryLocations: action.payload?.total || 0,
        lastDeletedDiscoveryId: null,
      };

    case GET_DISCOVERY_LOCATIONS_FAILED:
      return {
        ...state,
        isLoadingDiscoveryLocations: false,
        lastDeletedDiscoveryId: null,
      };

    case DELETE_DISCOVERY_LOCATION:
      return {
        ...state,
        isDeletingDiscoveryLocation: true,
      };

    case DELETE_DISCOVERY_LOCATION_SUCCESS:
      return {
        ...state,
        isDeletingDiscoveryLocation: false,
        discoveryLocations: state.discoveryLocations,
        totalDiscoveryLocations: state.totalDiscoveryLocations,
        lastDeletedDiscoveryId: action.payload?.id || null,
      };

    case DELETE_DISCOVERY_LOCATION_FAILED:
      return {
        ...state,
        isDeletingDiscoveryLocation: false,
        lastDeletedDiscoveryId: null,
      };

    default:
      return state;
  }
};

export default discoveryLocationReducer;
